import React, { useContext } from 'react';
import {
  Typography,
  Dialog,
  Toolbar,
  IconButton,
  DialogContent,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { I18nContext } from 'translations';
import BulkEditErrorsTable from 'components/Tables/Settings/Users/BulkEditErrorsTable';

const ModalBulkEditErrors = ({ open, handleClose, errors, updated }) => {
  const { translate } = useContext(I18nContext);

  return (
    <Dialog fullWidth maxWidth="md" open={open}>
      <Toolbar style={{ justifyContent: 'center' }}>
        <IconButton
          edge="end"
          color="primary"
          onClick={handleClose}
          aria-label="close"
          style={{ position: 'absolute', right: 20, top: '10px' }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" color="textPrimary" className="text-center">
          {translate('app.settings.users.bulkEditErrors.title')}
        </Typography>
      </Toolbar>

      <DialogContent style={{ padding: '15px 30px 30px' }}>
        <Typography style={{ marginBottom: 12, textAlign: 'left' }}>
          <b>{translate('app.successful')}: </b>
          <span style={{ marginRight: 12 }}>{updated}</span>
          <b>{translate('app.failed')}: </b>
          <span>{errors.length}</span>
        </Typography>
        <BulkEditErrorsTable data={errors} />
      </DialogContent>
    </Dialog>
  );
};

export default ModalBulkEditErrors;
